export default "__VITE_ASSET__2H22MXls__"